export const capitalize = (source: string, restToLowerCase = false): string => {
  return source?.charAt(0).toUpperCase() + (restToLowerCase ? source?.toLowerCase() : source)?.slice(1);
};

